import { MdVerified, MdStar, MdCalendarToday, MdWorkOutline } from 'react-icons/md';
import { t } from '../../utils/i18n';

const BADGES = [
  { key: 'verified', icon: MdVerified },
  { key: 'reviews', icon: MdStar },
  { key: 'tracking', icon: MdCalendarToday },
  { key: 'payment', icon: MdWorkOutline },
];

export default function TrustBadges() {
  return (
    <ul className="landing-trust-strip">
      {BADGES.map(({ key, icon: Icon }) => (
        <li key={key} className="landing-trust-chip">
          <Icon className="text-sm opacity-70" aria-hidden="true" />
          {t(`landing.trust.${key}`)}
        </li>
      ))}
    </ul>
  );
}
